import { MutationCache, QueryClient } from '@tanstack/react-query';

import { getErrorMessage } from '@/shared/api/http';
import { toast } from '@/shared/stores/toastStore';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    // Every failed mutation surfaces a global error toast. Forms may still
    // show inline errors; the toast guarantees feedback even when the
    // trigger (e.g. a row action) has no inline error slot. getErrorMessage
    // is the single sanitiser — it never leaks a raw error string.
    mutationCache: new MutationCache({
      onError: (error) => toast.error('Action failed', getErrorMessage(error)),
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
